import { render, staticRenderFns } from "./DriverShell.vue?vue&type=template&id=4df4237e&"
import script from "./DriverShell.vue?vue&type=script&lang=ts&"
export * from "./DriverShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports